module.exports = __webpack_public_path__ + "img/avatar6.b1d6b413.png";